<template>
  <div>
    <div class="m-paymentMethod m-paymentMethod--rowSpaceBetween"
      v-for="paymentMethod in storedPaymentMethods"
      v-bind:key="paymentMethod.token"
      v-bind:row="paymentMethod.token"
      @click="selectPaymentMethod(paymentMethod)">
      <div class="m-paymentMethod--row">
        <div class="a-input-radio">
          <input type="radio" name="paymenttoken" class="a-input-radio__input" :value="paymentMethod.token" v-model="selected.token"/>
          <div class="a-input-radio__check"></div>
        </div>
        <img 
          v-bind:src="getPaymentMethodInformations(paymentMethod).imageUrl"
          :class="['pay-logo', getPaymentMethodInformations(paymentMethod).type]"/>
        <p class="cc">{{ getPaymentMethodInformations(paymentMethod).details }}</p>
      </div>
      <transition name="fade" class="m-paymentMethod__delete">
        <i v-if="selected.token === paymentMethod.token && paymentMethod.deletable"
          class="far fa-trash-alt" aria-hidden="true" @click="showDialog"></i>
      </transition>
    </div>
    <!-- Start modal -->
    <modal-dialog ref="modalDialog" v-show="showModal">close
      <p slot="header">Are you sure you want to delete this payment method?</p>
      <div slot="body">
        <button
          id="confirm-button"
          class="modal-body__Button a-Button--Small a-Button--LightBlue"
          @click="deletePaymentMethod">
          Yes
        </button>
        <button
          id="cancel-button"
          class="modal-body__Button a-Button--Small a-Button--LightBlue"
          @click="closeDialog">
          Cancel
        </button>
      </div>
    </modal-dialog>
    <!-- End modal -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Axios from 'axios'
import Vue from 'vue'

// code split/lazy load the ModalDialog
const ModalDialog = Vue.component('ModalDialog', function (resolve) {
  require(['../organisms/ModalDialog.vue'], resolve)
})

export default {
  computed: mapState({
    paymentsAssetUrl: state => state.globalstate.paymentsAssetUrl,
    storedPaymentMethods: state => state.globalstate.paymentGatewayInfo.storedPaymentMethods
  }),
  props: ['paymentFlow'],
  components: { ModalDialog },
  data () {
    return {
      showModal: false,
      selected: {
        token: '',
        type: ''
      },
      paymentFlowTypes: {
        subscription: 'vault',
        nonSubscription: 'checkout'
      }
    }
  },
  watch: {
    storedPaymentMethods () {
      // Only change that is ever observed is deletion, make sure to close
      // the modal dialog when deleted.
      this.setDefaultPaymentMethod()
      this.closeDialog()
    }
  },
  methods: {
    showDialog () {
      this.showModal = true
    },
    closeDialog () {
      this.showModal = false
    },
    setDefaultPaymentMethod () {
      // WE only want to set default payment method when there is a subscription purchase (vault flow).
      // For permanent license purchases (checkout flow), we want to use the temporary payment token returned
      // because the checkout flow does not add a payment method.
      if (this.paymentFlow === this.paymentFlowTypes.subscription) {
        this.selectPaymentMethod(this.storedPaymentMethods.find(pm => pm.isDefault))
      }
    },
    getPaymentMethodInformations (paymentMethod) {
      let paymentMethodType = ''
      let paymentMethodDetails = ''
      let paymentMethodImageUrl = ''
      switch (paymentMethod.type) {
        case 'CreditCard':
          switch (paymentMethod.cardType) {
            case 'Visa':
              paymentMethodType = 'visa'
              paymentMethodImageUrl = this.paymentsAssetUrl.visa
              break
            case 'MasterCard':
              paymentMethodType = 'mastercard'
              paymentMethodImageUrl = this.paymentsAssetUrl.mastercard
              break
            default:
              break
          }
          paymentMethodDetails = paymentMethod.maskedNumber + ' - Expires ' + paymentMethod.expirationDate
          break
        case 'PayPalAccount':
          paymentMethodType = 'paypal'
          paymentMethodDetails = paymentMethod.email
          paymentMethodImageUrl = this.paymentsAssetUrl.paypal
          break
        default:
          break
      }
      return { type: paymentMethodType, details: paymentMethodDetails, imageUrl: paymentMethodImageUrl }
    },
    selectPaymentMethod (paymentMethod) {
      if (paymentMethod !== undefined) {
        this.selected = paymentMethod
        this.$emit('selectPaymentMethod', this.selected)
      }
    },
    deletePaymentMethod () {
      Axios.delete('/payment/delete', { params: { 'paymentMethodToken': this.selected.token }})
      .then((response) => { this.$store.dispatch('globalstate/fetch') })
      .catch(() => {
        this.$store.dispatch('globalstate/error', { error: 'This payment method has an active subscription.' })
      })
    }
  },
  mounted () {
    this.setDefaultPaymentMethod()
  }
}
</script>


// WEBPACK FOOTER //
// SavedMethods.vue?1089a937